export enum PresentationModeEnum {
    TEXT = 'TEXT',
    VOICE = 'VOICE',
    CUSTOM = 'CUSTOM'
}
